export interface SectionRouteData {
    section1: string | null;
    section2: string | null;
    section3: string | null;
    product: string | null;
    productId: string | null;
}

export const getRouteDataFromURLSegments = (
    section1Segment: string | null,
    section2Segment: string | null,
    section3Segment: string | null,
    productSegment: string | null,
): SectionRouteData => {
    const productRegex = /(?:.*?)-([\d_]{5,})$/;
    let routeData: SectionRouteData = {
        section1: section1Segment,
        section2: section2Segment,
        section3: section3Segment,
        product: productSegment,
        productId: null,
    };

    if (productSegment) {
        const productMatch = productSegment?.match(productRegex);
        routeData = { ...routeData, productId: productMatch?.[1] || null };
        return routeData;
    }

    routeData.product = null;

    if (section3Segment) {
        const productMatch = section3Segment?.match(productRegex);
        routeData = { ...routeData, productId: productMatch?.[1] || null };
        return routeData;
    }

    routeData.section3 = null;

    if (section2Segment) {
        const productMatch = section2Segment?.match(productRegex);
        routeData = { ...routeData, productId: productMatch?.[1] || null };
        return routeData;
    }

    routeData.section2 = null;

    if (section1Segment) {
        const productMatch = section1Segment?.match(productRegex);
        routeData = { ...routeData, productId: productMatch?.[1] || null };
        return routeData;
    }

    routeData.section1 = null;

    return routeData;
};
